import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import products from "../../../Data/products.json";
import units from "../../../Data/units.json";
import categories from "../../../Data/category.json";
import brands from "../../../Data/brands.json";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_all_products_reports,
  get_fast_moving_products_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import StockFL from "../../../Componets/FormatStock";

const ProductReports = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [total, setTotal] = useState();
  const [role, setRole] = useState("");

  const [grandTotalSold, setGrandTotalSold] = useState();
  const [grandTotalPurchase, setgGrandTotalPurchase] = useState();
  const [grandTotalSale, setGrandTotalSale] = useState();

  const headers = {
    name: "Products Moving Report",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
          { value: 2, label: "Quantity (Low)" },
          { value: 3, label: "Quantity (High)" },
          { value: 4, label: "Purchase Price (Low)" },
          { value: 5, label: "Purchase Price (High)" },
          { value: 6, label: "Sale Price (Low)" },
          { value: 7, label: "Sale Price (High)" },
          { value: 8, label: "Price Per Unit (Low)" },
          { value: 9, label: "Price Per Unit (High)" },
          { value: 10, label: "Net profit (Low)" },
          { value: 11, label: "Net profi (High)" },
          { value: 12, label: "Margin (Low)" },
          { value: 13, label: "Margin (High)" },
        ],
      },
      {
        type: "filter",
        name: "unit",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Units",
        api: "get-all-product-units",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "category",
        placeholder: "Category",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-categories",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "brand",
        placeholder: "Brands",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        api: "get-all-product-brands",
        value: null,
        options: null,
      },
      /*   {
          type: "filter",
          name: "type",
          placeholder: "Type",
          value: null,
          allowClear: true,
          showSearch: false,
          filterOption: true,
          options: [
            { value: 0, label: "Non-Stockable" },
            { value: 1, label: "Stockable" },
          ],
        }, */
      /*   {
          type: "filter",
          name: "status",
          placeholder: "Status",
          value: null,
          allowClear: true,
          showSearch: false,
          filterOption: true,
          options: [
            { value: "0", label: "Inactive" },
            { value: "1", label: "Active" },
          ],
        }, */
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Product",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: "0", label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        date: tabledata?.date,
        branch: tabledata?.branch,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      // const products = await get_all_products(data);
      const products = await get_fast_moving_products_reports(data);

      if (products?.status) {
        setBody(products?.data?.data);
        setTotal(products?.data);
        setRole(products?.data?.role)

        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const downloadCSV = () => {

    if (!body || body.length === 0) {
      console.log("No data available to download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = [
        "S.No",
        "Name",
        "Quantity",
        "Purchase Price",
        "Price Per Unit",
        "Sales Price",
        "Net Profit",
        "Margin"
      ];

      const rows = body.map((item, index) => {
        const qty = item?.totalSold?.toFixed?.(3) || 0;
        const purchase = item?.totalPurchasePrice?.toFixed?.(3) || 0;
        const perUnit = item?.totalPricePerUnit?.toFixed?.(3) || 0;
        const sale = item?.totalSalePrice?.toFixed?.(3) || 0;
        const profit = item?.netTotal?.toFixed?.(3) || 0;
        const margin = item?.margin?.toFixed?.(3) ? `${item.margin.toFixed(3)}%` : "0%";

        return [
          index + 1,
          item?.productName || "-",
          qty,
          purchase,
          perUnit,
          sale,
          profit,
          margin
        ];
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(value => `"${value}"`).join(","))
        .join("\n");

      const encodedContent = new TextEncoder().encode("\uFEFF" + csvContent);

      const blob = new Blob([encodedContent], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Product_Report_${new Date().toLocaleDateString().replace(/\//g, "_")}.csv`;
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("CSV Generation Error:", error);
      toast.error("Failed to generate CSV file");
    }
  };


  const downloadPDF = () => {
    if (!body || body.length === 0) return;

    const doc = new jsPDF();
    registerCairoFont(doc);
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Product Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.map((item, index) => [
      index + 1,
      item?.productName || "-",
      item?.totalSold?.toFixed?.(3) || 0,
      item?.totalPurchasePrice?.toFixed?.(3) || 0,
      item?.totalPricePerUnit?.toFixed?.(3) || 0,
      item?.totalSalePrice?.toFixed?.(3) || 0,
      item?.netTotal?.toFixed?.(3) || 0,
      item?.margin?.toFixed?.(3) ? `${item.margin.toFixed(3)}%` : "0%",
    ]);

    autoTable(doc, {
      startY: 32,
      head: [["S.No", "Name", "Quantity", "Purchase Price", "Price Per Unit", "Sales Price", "Net Profit", "Margin"]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
    });

    doc.save(`Product_Report_${formattedDate}.pdf`);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div className="text-right flex gap-3 justify-end mt-4">
          <Button
            className="mr-2  !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>
          <ReactToPrint
            trigger={() => (

              <Button
                className="mr-2  !bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb] hover:!border-[#0b9abb]"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
              @page {
                size: landscape;
                margin: 10mm;
              }

              @media print {
                tfoot {
                  position: static !important;
                  bottom: auto !important;
                }
                thead { 
                  display: table-header-group !important;
                }
                tfoot {
                  display: table-row-group !important;
                }
              }

                table {
                border-collapse: collapse;
                width: 100%;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 6px;
              }
              th {
                background-color: #f4f4f4;
              }

              @media print {

  table, thead, tbody, tfoot, tr, th, td {
    border: 1px solid #000 !important;
    border-collapse: collapse !important;
  }

  th {
    background-color: #f4f4f4 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  thead, tfoot {
    position: static !important;
  }
}
            `}
          />
        </div>


        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr className="text-sm">
                  <td className="border p-4">S.No</td>
                  <td className="border p-4">Name</td>
                  <td className="border p-4">Quantity</td>
                  <td className="border p-4">Purchase Price</td>
                  <td className="border p-4">Price Per Unit</td>
                  <td className="border p-4">Sales Price</td>
                  <td className="border p-4">Net Profit</td>
                  <td className="border p-4">Margins</td>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr className="text-xs">
                      <td className="border p-4">{index + 1}</td>
                      <td className="border p-4">{value?.productName}</td>
                      <td className="border p-4">
                        <StockFL
                          totalStock={value?.totalSold}
                          conversion={value?.product_units_details?.[0]?.conversion || 1}
                        />
                      </td>
                      <td className="border p-4">
                        {value?.totalPurchasePrice
                          ? value?.totalPurchasePrice?.toFixed?.(3)
                          : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.totalPricePerUnit
                          ? value?.totalPricePerUnit?.toFixed?.(3)
                          : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.totalSalePrice
                          ? value?.totalSalePrice?.toFixed?.(3)
                          : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.netTotal ? value?.netTotal?.toFixed?.(3) : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.marginPercentage
                          ? parseFloat?.(value?.marginPercentage)?.toFixed?.(3) +
                          "%"
                          : "0%"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-4 text-medium">TOTAL</td>
                  <td className="border p-4"></td>
                  <td className="border p-4 text-medium">
                    {/* {total?.grandTotalSale ? total?.grandTotalSold : "0.000"} */}
                  </td>
                  <td className="border p-4 text-medium">
                    {total?.grandTotalPurchase
                      ? total?.grandTotalPurchase?.toFixed?.(3)
                      : "0.000"}
                  </td>
                  <td className="border p-4 text-medium">
                    {total?.grandTotalPricePerUnit
                      ? total?.grandTotalPricePerUnit?.toFixed?.(3)
                      : "0.000"}
                  </td>
                  <td className="border p-4 text-medium">
                    {total?.grandTotalSale
                      ? total?.grandTotalSale?.toFixed?.(3)
                      : "0.000"}
                  </td>
                  <td className="border p-4 text-medium">
                    {total?.grandNetTotal
                      ? total?.grandNetTotal?.toFixed?.(3)
                      : "0.000"}
                  </td>
                  <td className="border p-4 text-medium">
                    {/* {total?.grandNetTotal
                  ? total?.grandNetTotal?.toFixed?.(3)
                  : "0.000"} */}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default ProductReports;
